import type WorkTimeSlot from 'owa-service/lib/contract/WorkTimeSlot';
import type { BookingsWorkTimeSlot } from 'owa-graph-schema';

const mapBookingsWorkTimeSlot = (timeSlots: BookingsWorkTimeSlot[]): WorkTimeSlot[] => {
    const modifiedTimeSlots: WorkTimeSlot[] =
        timeSlots?.map(timeSlot => ({
            StartTimeInMinutes: timeSlot.start ?? 0,
            EndTimeInMinutes: timeSlot.end ?? 0,
        })) ?? [];
    return modifiedTimeSlots;
};

export default mapBookingsWorkTimeSlot;
